import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const bgTex = "https://static.prod-images.emergentagent.com/jobs/432d7502-8e49-47be-aa92-bd971f421dad/images/ca4bba3426af11d33e3eed4bf0cf8bde842c3cc7cbb7478327667838bdcef44d.png";

export const FinalCTA = () => {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden" data-testid="final-cta-section">
      <div
        className="absolute inset-0 opacity-30"
        style={{ backgroundImage: `url(${bgTex})`, backgroundSize: "cover", backgroundPosition: "center" }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#080C14] via-[#080C14]/70 to-[#080C14]" />
      <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <div className="corner-bracket tl" />
        <div className="corner-bracket tr" />
        <div className="corner-bracket bl" />
        <div className="corner-bracket br" />
        <div className="py-12 px-4">
          <span className="pill">Last Call</span>
          <h2 className="mt-5 font-display font-black text-white text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-none">
            Stop scrolling. <br />
            <span className="text-[#3B9EFF]">Start posting.</span>
          </h2>
          <p className="mt-6 text-lg text-[#A0AABF] max-w-2xl mx-auto">
            Pick your plan. Fill the form. Get content in 72–96 hours. That's it.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Link to="/offer/pack-99" className="btn-primary" data-testid="final-cta-99">
              Get $99.99 Pack <ArrowRight size={18} />
            </Link>
            <Link to="/offer/monthly-175" className="btn-secondary" data-testid="final-cta-175">
              Go Monthly $175/mo <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
